import { CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import * as React from "react";
import { useState } from "react";
import {
  BooleanInput,
  Button,
  Create,
  RadioButtonGroupInput,
  required,
  SelectArrayInput,
  SelectInput,
  TextInput,
  Toolbar,
  useDataProvider,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { SectionTitle } from "../../../src/Components/SectionTitle";
import { Separator } from "../../../src/Components/Separator";
import { useAppDataProvider } from "../../../src/dataprovider";
import { SourceQuarantineReasonList, WebSuiteChoices } from "../Quarantine/Constant/Source";
import { QuarantineDetailCreate } from "../Quarantine/Model/QuarantineDetailModel";
import { QuarantinePostModel } from "../Quarantine/Model/QuarantineModel";
import QuarantineInput from "../../Components/ReferenceFields/Quarantine/QuarantineInput";
import { QuarantineUnitType } from "../../Constants/Constant";
import { QuarantineLocations } from "../../Constants/Constant";
import { QuarantineReasons } from "../../../src/Enums/QuarantineReasons";
import { QuarantineStatusType } from "../../../src/Enums/QuarantineStatusType";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};
const QuarantineCreate = props => {
  const dataProvider = useAppDataProvider();
  const provider = useDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [webSuiteRef, setWebSuiteRef] = useState(true);
  const [remarkRequired, setRemarkRequired] = useState(false);
  const [quarantineData, setQuarantineData] = useState([] as any);
  const [quarantineReasons, setQuarantineReasons] = useState([] as any);
  const [initialRefNo, setInitialRefNo] = useState();
  const validate = [];

  const useStyles = makeStyles({
    toolbar: {
      display: "flex",
      justifyContent: "end",
      backgroundColor: "white",
    },
    defaultToolbar: {
      display: "flex",
      justifyContent: "end",
    },
  });

  const classes = useStyles();

  React.useEffect(() => {
    if ((history as any)?.location?.state?.refNo) {
      setInitialRefNo((history as any)?.location?.state?.refNo);
      history.replace({
        pathname: `/quarantines/create`,
        state: {},
      });
    }
    provider
      .getList(SourceQuarantineReasonList, {
        pagination: { page: 1, perPage: 999 },
        sort: { field: "id", order: "DESC" },
        filter: {},
      })
      .then(response => {
        if (response.data.length > 0) {
          setQuarantineReasons(
            response.data.filter(t => {
              return t.id !== QuarantineReasons.NoWebSuite;
            })
          );
        }
      })
      .catch(error => {
        console.log(error);
      });
  }, []);
  React.useEffect(() => {
    provider
      .getList("requestorders/quarantine", {
        pagination: { page: 1, perPage: 999 },
        sort: { field: "id", order: "DESC" },
        filter: {},
      })
      .then(response => {
        if (response.data.length > 0) {
          setQuarantineData(response.data);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }, []);

  const changeQuarantineReason = form => value => {
    const formValue = form?.getState?.()?.values ?? {};

    if (formValue.quarantineReasons.find(condition => condition == QuarantineReasons.Other) !== undefined) {
      setRemarkRequired(true);
    } else {
      setRemarkRequired(false);
    }
  };

  const changeWebSuiteRef = form => value => {
    const formValue = form?.getState?.()?.values ?? {};

    if (formValue.isWebSuiteRef === false) {
      setWebSuiteRef(false);
    } else {
      setWebSuiteRef(true);
    }
  };

  const CreateQuarantineButtonClick = e => {
    CreateQuarantine(e);
  };

  const CreateQuarantine = async e => {
    let quarantineCreateModel: QuarantinePostModel = new QuarantinePostModel();
    let requestReasonListCreate = [] as QuarantineDetailCreate[];

    if (e.quarantineReasons !== undefined) {
      e.quarantineReasons.forEach(reason => {
        let quarantineDetailModel: QuarantineDetailCreate = new QuarantineDetailCreate();
        quarantineDetailModel.QuarantineReasonId = reason;
        quarantineDetailModel.QuarantineReasonStatus = QuarantineStatusType.Open; // Status 0 Open
        requestReasonListCreate.push(quarantineDetailModel);
      });
    }

    if (webSuiteRef === false) {
      let quarantineDetailModel: QuarantineDetailCreate = new QuarantineDetailCreate();
      quarantineDetailModel.QuarantineReasonId = QuarantineReasons.NoWebSuite;
      quarantineDetailModel.QuarantineReasonStatus = QuarantineStatusType.Open; // Status 0 Open
      requestReasonListCreate.push(quarantineDetailModel);
    }

    quarantineCreateModel.RefNo = e.refNo;
    quarantineCreateModel.QuarantineReasons = requestReasonListCreate;
    quarantineCreateModel.CustomerName = e.customerName;
    quarantineCreateModel.CustomerPo = e.customerPo;
    quarantineCreateModel.UnitType = e.unitType;
    quarantineCreateModel.UnproperPacking = e.unproperPacking;
    quarantineCreateModel.QuarantineRemark = e.quarantineRemark;
    quarantineCreateModel.Pn = e.pn;
    quarantineCreateModel.Sn = e.sn;
    quarantineCreateModel.AwbNo = e.awbNo;
    quarantineCreateModel.Location = e.location;

    dataProvider
      .postQuarantine(quarantineCreateModel)
      .then(result => {
        notify(`Record created`, "success", false, true);
        history.push("/quarantines");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  return (
    <Form
      initialValues={{ refNo: initialRefNo, isWebSuiteRef: true }}
      onSubmit={CreateQuarantineButtonClick}
      render={({ handleSubmit, form, values }) => (
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Create {...props}>
                <>
                  <Separator />
                  <Grid {...gridContainerProps}>
                    <SectionTitle label="Quarantine" />
                  </Grid>
                  <Separator />

                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <RadioButtonGroupInput
                        label="Is Ref No Exists"
                        source="isWebSuiteRef"
                        initialValue={true}
                        fullWidth
                        choices={WebSuiteChoices}
                        onChange={changeWebSuiteRef(form)}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <BooleanInput label="UNPROPER PACKING" source="unproperPacking" defaultValue={false} fullWidth />
                    </Grid>
                  </Grid>

                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      {webSuiteRef == true && <QuarantineInput form={form} quarantinedata={quarantineData} />}
                    </Grid>

                    <Grid item xs={12} sm={5}>
                      <SelectArrayInput
                        source="quarantineReasons"
                        choices={quarantineReasons}
                        optionText="quarantineReasonName"
                        optionValue="quarantineReasonEnum"
                        validate={webSuiteRef == true ? required() : validate}
                        onChange={changeQuarantineReason(form)}
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="customerName"
                        label="CUSTOMER NAME"
                        fullWidth
                        resettable
                        variant="outlined"
                        isRequired={true}
                        disabled={webSuiteRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="customerPo"
                        label="CUSTOMER PO"
                        fullWidth
                        resettable
                        variant="outlined"
                        validate={required()}
                        disabled={webSuiteRef}
                      />
                    </Grid>
                  </Grid>
                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="pn"
                        label="PN"
                        fullWidth
                        resettable
                        variant="outlined"
                        validate={required()}
                        disabled={webSuiteRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="sn"
                        label="SN"
                        fullWidth
                        resettable
                        variant="outlined"
                        validate={required()}
                        disabled={webSuiteRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={5} />
                  </Grid>
                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="awbNo"
                        label="AWB Number"
                        fullWidth
                        resettable
                        variant="outlined"
                        //validate={required()}
                        disabled={webSuiteRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <SelectInput
                        source="location"
                        label="LOCATION"
                        optionText="locations"
                        optionValue="value"
                        fullWidth
                        resettable
                        choices={QuarantineLocations}
                        variant="outlined"
                        validate={required()}
                      />
                    </Grid>
                  </Grid>
                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <SelectInput
                        source="unitType"
                        label="UNIT TYPE"
                        optionText="unitTypes"
                        optionValue="value"
                        defaultValue={"No Information"}
                        fullWidth
                        resettable
                        choices={QuarantineUnitType}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="quarantineRemark"
                        label="QUARANTINE REMARKS"
                        multiline
                        fullWidth
                        resettable
                        validate={remarkRequired == true ? required() : validate}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>

                  <Separator />
                  <Toolbar {...props} placeholder="" classes={classes}>
                    <Button
                      label={loading ? "Quarantine is creating!" : "Create Quarantine"}
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                    >
                      {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                    </Button>
                  </Toolbar>
                </>
              </Create>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};

export default QuarantineCreate;
